module.exports = __webpack_public_path__ + "static/media/rawfish.8feb43fb.svg";